import { Component, OnInit } from '@angular/core';
import { GlobalConstants } from 'src/app/common/constants/global.constant';
import { Router } from '@angular/router';
import { PromoContentService } from 'src/app/core/services/promo-content-service/promo-content.service';
import { environment } from 'src/environments/environment';
import { QrCodeService } from 'src/app/core/services/qr-input-service/qr-input.service';
import { GoogleAnalyticsService } from 'src/app/core/services/google-analytics-service/google-analytics.service';

@Component({
  selector: 'app-promo-content-overview',
  templateUrl: './promo-content-overview.component.html',
  styleUrls: ['./promo-content-overview.component.scss']
})
export class PromoContentOverviewComponent implements OnInit {
  promoTileData: any;
  setIntelDisplayOneFont: boolean;
  isRTL: boolean = false;

  constructor(private promoContentService: PromoContentService,
    private router: Router,
    private qrCodeService: QrCodeService,
    private googleAnalyticsService: GoogleAnalyticsService
  ) { }

  ngOnInit(): void {
    this.promoTileData = this.promoContentService.promoData;
    this.setIntelDisplayOneFont = this.qrCodeService.setenusLang();
    this.isRTL =this.qrCodeService?.qrInput?.Language === "ar-sa" || this.qrCodeService?.qrInput?.Language === "he";
  }

  setBackground(promoId: string, configValue: any) {
    let colorStr = '';
    let backgroundColorStr = '';
    let bgImageUrl = '';
    let bkgColor = '';
    let titleColor = '';

    if (configValue?.contentGroupPages?.length > 0) {
      bkgColor = configValue?.contentGroupPages[0]?.bgColor;
      titleColor = configValue?.contentGroupPages[0]?.titleFontColor;
      if (configValue?.contentGroupPages[0]?.linkedAssetFileType.includes(GlobalConstants.PROMO_CONTENT_IMAGE_FILE)) {
        const userID = this.qrCodeService?.qrInput?.UserId;
        bgImageUrl = environment.apiBaseUrlAsset + GlobalConstants.PROMO_ASSETS_URL_PART1 + userID + GlobalConstants.PROMO_ASSETS_URL_PART2 + userID + GlobalConstants.PROMO_URL2_PART2 + promoId + GlobalConstants.PROMO_PAGE1_ASSETS;
      }
    }
    if (bkgColor && titleColor) {
      colorStr = titleColor;
      backgroundColorStr = bkgColor;

    } else {
      colorStr = '#ffffff';
      backgroundColorStr = '#005FA9';
    }

    if (bgImageUrl) {
      return {
        color: colorStr,
        backgroundColor: backgroundColorStr,
        backgroundImage: 'url(' + bgImageUrl + ')'
      };
    }
    else {
      return {
        color: colorStr,
        backgroundColor: backgroundColorStr
      };
    }
  }

  routeToTileDetailsPage(tileUrl: string, index: number) {
    this.promoContentService.setSelectedPromoIndex(index);
    const storePromoName = this.promoTileData[index].configurations.publishedName;
    this.googleAnalyticsService.factTagAnalytics(storePromoName,tileUrl); 
    this.router.navigateByUrl('/', { skipLocationChange: true }).then(() => {
      this.router.navigate(['/mob-content/promo-tiles']);
    });
  }

}
